<template>
  <v-dialog
    width="500px"
    :value="value"
    persistent
  >
    <v-card>
      <v-card-title class="warningHeader font-weight-bold">
        {{ $t('dialogs.warning.title') }}
      </v-card-title>

      <v-card-text class="mt-1 pb-3 pt-2 subtitle-2 font-weight-bold">
        {{ message }}
      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn dark color="warning" @click="dismissDialog()">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    message: String,
  },

  methods: {
    dismissDialog() {
      this.$emit('dismiss-dialog');
    },
  },
};
</script>

<style scoped>
.warningHeader {
  color: white;
  background-color: var(--v-warning-base);
}
</style>
